import { OverlayPlacement } from '@nextui-org/aria-utils/dist/overlays/types';
import { Button, Popover, PopoverContent, PopoverTrigger, Tooltip } from '@nextui-org/react';
import React, { ReactNode, useState } from 'react';

type IconTooltipPopoverUIProps = {
  isDisabled?: boolean;
  children: ReactNode | ((onClose: () => void) => ReactNode);
  popoverPlacement: OverlayPlacement;
  tooltip: string;
  icon: ReactNode;
};

export const IconTooltipPopoverUi = (props: IconTooltipPopoverUIProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => setIsOpen(false);
  const toggleOpen = () => setIsOpen(!isOpen && true);

  return (
    <Popover placement={props.popoverPlacement} isOpen={isOpen} onOpenChange={open => setIsOpen(open)}>
      <PopoverTrigger>
        <Button
          isDisabled={props.isDisabled}
          isIconOnly
          variant='light'
          color='danger'
          onPress={toggleOpen}
          className='min-w-6 w-6 h-6'
        >
          <Tooltip
            content={props.tooltip}
            placement='top'
            closeDelay={0}
            classNames={{
              content: 'bg-[#F9E79F]',
            }}
          >
            {props.icon}
          </Tooltip>
        </Button>
      </PopoverTrigger>
      <PopoverContent>{typeof props.children === 'function' ? props.children(onClose) : props.children}</PopoverContent>
    </Popover>
  );
};
